module.exports = __webpack_public_path__ + "front/img/kv_offline.8913ec8c.png";